import InputData from "../components/InputData";
import InputIconSearchPanelMultiSelection from "../components/InputIconSearchPanelMultiSelection";
import Tag from "../components/Tag";
import ButtonIconH from "./ButtonIconH";
import DataTable from "react-data-table-component";
import TooltipBox from "./Tooltip";
import moment from "moment";
import {
  userData,
  crmChannels,
  inputOnEnter,
  formatValueUnit,
} from "../js/utils";
import { useCallback, useEffect, useState } from "react";
import { CRMCampaignsColumns } from "../js/tableColumns";
import ActionPopup from "../components/ActionPopup";
import { CRMCampaign } from "../components/CRMCampaign";
import { CRMCampaignStats } from "./CRMCampaignStats";
import { post } from "../js/post";

export function CRMCampaigns() {
  const [actionPopup, setActionPopup] = useState(false);
  const [actionComponent, setActionComponent] = useState(null);
  const [filterName, setFilterName] = useState("");
  const [filterDate, setFilterDate] = useState({
    start: "",
    end: "",
  });
  const [start, setStart] = useState(0);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [campaignsList, setCampaignsList] = useState([]);
  const [campaignsListFixed, setCampaignsListFixed] = useState([]);
  const [totalCamps, setTotalCamps] = useState(0);
  const [handleCampaign, setHandleCampaign] = useState({
    toggle: false,
    id: -1,
  });

  const columnsWithInputs = CRMCampaignsColumns.map((col) => {
    if (col.name === "") {
      return {
        ...col,
        selector: (row) => (
          <button
            onClick={() => {
              handleOpenActionPopup("campaignStats", row);
            }}
          >
            <img
              src="/images/stats-blue.svg"
              className="icon-pref"
              data-tooltip-id={row.idCampana}
              alt="Estadísticas"
            ></img>
            <TooltipBox
              id={String(row.idCampana)}
              content={
                <div className="opt-table-tooltip grid-5">
                  <div className="cell combined-cells-5 cell-start-content">
                    Estadísticas
                  </div>
                </div>
              }
            ></TooltipBox>
          </button>
        ),
      };
    }

    return col;
  });

  const getCampaignsList = useCallback(
    async (start) => {
      const response = await post("support-extra/crm/ListarCampanasCRM.php", {
        token: userData.token,
        nombre: filterName,
        fechaDesde: filterDate.start,
        fechaHasta: filterDate.end,
        canal: selectedChannels,
        start,
      });
      // console.log(
        // "LISTAR CAMPAÑAS: ",
        // {
          // token: userData.token,
          // nombre: filterName,
          // fechaDesde: filterDate.start,
          // fechaHasta: filterDate.end,
          // canal: selectedChannels,
          // start,
        // },
        // response,
      // );
      setTotalCamps(response.total);
      if (start === 0) {
        setCampaignsList(response.campanas);
        setCampaignsListFixed(response.campanas);
      } else {
        setCampaignsList(response.campanas);
      }
    },
    [filterName, filterDate, selectedChannels],
  );

  const handleOpenActionPopup = (componentType, id) => {
    switch (componentType) {
      case "campaignStats":
        setActionComponent({
          name: "Estadísticas de campaña",
          component: <CRMCampaignStats campaign={id} />,
        });
        break;
      default:
        setActionComponent(null);
    }
    setActionPopup(true);
  };

  function resetFilters() {
    setFilterName("");
    setFilterDate({ start: "", end: "" });
    setSelectedChannels([]);
  }

  useEffect(() => {
    getCampaignsList(start);
  }, [start, getCampaignsList]);

  useEffect(() => {
    setCampaignsListFixed([]);
    setStart(0);
  }, [filterName, filterDate, selectedChannels]);

  useEffect(() => {
    setCampaignsListFixed((prev) => {
      const newCampaigns = campaignsList.filter(
        (newCampaign) =>
          !prev.some(
            (existingCampaign) =>
              existingCampaign.idCampana === newCampaign.idCampana,
          ),
      );

      return [...prev, ...newCampaigns];
    });
  }, [campaignsList]);

  return (
    <div className="thin-rounded-border">
      {actionPopup && (
        <ActionPopup
          name={actionComponent.name}
          children={actionComponent.component}
          overflowStyle={false}
          customClass="background-crm"
          fullscreen={actionComponent.name === "Estadísticas de campaña"}
          onClose={() => {
            setActionPopup(false);
            setActionComponent(null);
          }}
        ></ActionPopup>
      )}
      {handleCampaign.toggle && (
        <CRMCampaign
          id={handleCampaign.id}
          onSave={async () => {
            setStart(0);
            await getCampaignsList(0);
          }}
          onClose={() => {
            setHandleCampaign({ toggle: false, id: -1 });
          }}
        />
      )}
      <div>
        <div className="opt-table-content grid-13" id="crm-campaigns-lists">
          <div className="cell cell-start-content">Nombre</div>
          <div className="cell">
            <InputData
              tabIndex={1}
              type="type-alphanum-ext"
              size={0}
              input={filterName}
              onChange={(e) => {
                setFilterName(e);
              }}
            ></InputData>
          </div>
          <div className="cell"></div>
          <div className="cell cell-start-content">Fecha desde</div>
          <div className="cell">
            <input
              type="date"
              max="9999-12-31"
              tabIndex={2}
              className="input-field input-cell"
              value={filterDate.start}
              onChange={(e) => {
                const value = e.target.value;
                setFilterDate((prev) => ({
                  start: value ? moment(value).format("YYYY-MM-DD") : "",
                  end: prev.end,
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            ></input>
          </div>
          <div className="cell"></div>
          <div className="cell cell-start-content">Fecha hasta</div>
          <div className="cell">
            <input
              type="date"
              max="9999-12-31"
              tabIndex={3}
              className="input-field input-cell"
              value={filterDate.end}
              onChange={(e) => {
                const value = e.target.value;
                setFilterDate((prev) => ({
                  start: prev.start,
                  end: value ? moment(value).format("YYYY-MM-DD") : "",
                }));
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            ></input>
          </div>
          <div className="cell"></div>
          <div className="cell cell-start-content">Canal</div>
          <div className="cell">
            <InputIconSearchPanelMultiSelection
              size={0}
              tabIndex={4}
              type={"type-alphanum-ext"}
              options={crmChannels}
              selectedOptions={selectedChannels}
              onChange={(e) => {
                setSelectedChannels(e);
              }}
            ></InputIconSearchPanelMultiSelection>
          </div>
          <div className="cell"></div>
          <div className="cell">
            <button className="cell-label" onClick={resetFilters} tabIndex={-1}>
              Limpiar filtros
            </button>
          </div>
          <div className="combined-cells-9"></div>
          <div
            className="cell combined-cells-2"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            {selectedChannels.length > 0 && (
              <span style={{ fontWeight: "500", fontSize: 13 }}>
                Canales seleccionados: {selectedChannels.length}
              </span>
            )}
            <div className="tag-content">
              {selectedChannels.map((e, i) => {
                return (
                  <Tag
                    text={e}
                    key={i}
                    tagId={i}
                    onClick={(e) => {
                      setSelectedChannels((prev) =>
                        prev.filter((channel) => channel !== e),
                      );
                    }}
                  ></Tag>
                );
              })}
            </div>
          </div>
          <div className="combined-cells-2"></div>
        </div>
        <div className="opt-table-title opt-table-title-button">
          <div>
            Listado de campañas ({formatValueUnit(campaignsListFixed.length)} de{" "}
            <span style={{ color: "#41b3ff" }}>
              {formatValueUnit(totalCamps)}
            </span>
            )
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 30,
            }}
          >
            <ButtonIconH
              text="Nueva campaña"
              small={true}
              highlight={true}
              onClick={() => {
                setHandleCampaign({ toggle: true, id: -1 });
              }}
            ></ButtonIconH>
          </div>
        </div>
        <DataTable
          columns={columnsWithInputs}
          data={campaignsListFixed}
          className="custom-datatable"
          noDataComponent="No hay campañas disponibles."
          onRowClicked={(row, event) => {
            setHandleCampaign({ toggle: true, id: row.idCampana });
          }}
        />
      </div>
      {campaignsListFixed.length !== totalCamps && (
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 10 }}
        >
          <ButtonIconH
            text="Ver más (+20)"
            small={true}
            onClick={() => {
              setStart((prev) => prev + 20);
            }}
          ></ButtonIconH>
        </div>
      )}
    </div>
  );
}
